<p-dialog [(visible)]="displayAddEvent" (onHide)="cancel()" [modal]="true" [maximizable]="false"
[responsive]="true" [style]="{width: '70vw', minHeight: '80vh'}" appendTo="body">
    <ng-template pTemplate="header">
        <div class="w-100 p-d-flex">
            <h5 class="p-mb-0 p-mt-1">Event</h5>
            <p-dropdown [options]="usersInCalendar" optionLabel="label" [(ngModel)]="selectedVendorUser"
            appendTo="body" class="noBorderDD p-ml-2"></p-dropdown>
        </div>
    </ng-template>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <form (ngSubmit)="save()" #createEvent="ngForm">
                    <div style="width: min-content">
                        <label style="font-size: 0.9rem">Title<span style="color: red">*</span></label>
                    </div>
                    <div>
                        <input type="text" id="eventTitle" name="eventTitle" required="true" pInputText #eventTitle="ngModel"
                            [(ngModel)]="eventTemp.calendarEvent.name" placeholder="Enter Title" [ngClass]="{
                                'p-invalid':
                                    eventTitle.invalid &&
                                    (eventTitle.touched || eventTitle.dirty)
                            }" [disabled]="isViewMode" />
                        <small *ngIf="
                                eventTitle.invalid &&
                                (eventTitle.touched || eventTitle.dirty)
                            " style="font-size: 0.9rem" class="p-invalid">
                            Event Title is required</small>
                    </div>

                    <div class="p-d-flex" style="padding-top: 15px">
                        <!-- (onKeyUp)="onKeyUp($event, 'to')" (onBlur)="onBlur($event, 'to')" -->
                        <div class="p-mt-2 p-mr-3">Required:</div>
                        <div style="flex-grow: 1">
                            <p-autoComplete class="width-inherit" field="name" [required]="true" name="toRecipients"
                                placeholder="Add required attendees" #toRecipients id="toRecipients"
                                [ngModelOptions]="{ standalone: true }" [forceSelection]="true" [(ngModel)]="requiredCalendarEventAttendees"
                                [suggestions]="usersList" [completeOnFocus]="true" (completeMethod)="search($event.query)"
                                [multiple]="true" ngDefaultControl [disabled]="isViewMode" (click)="toRecipients.show()">
                                <ng-template let-toRecipients pTemplate="item">
                                    {{
                                    toRecipients?.name +
                                    "<" + toRecipients.emailId + ">" }} </ng-template>
                            </p-autoComplete>
                        </div>
                        <button [disabled]="isViewMode" pButton class="right-button" type="button" icon="pi pi-plus"
                            label="Optional" (click)="showOptional()"></button>
                    </div>
                    <div class="p-d-flex" *ngIf="isShown" style="padding-top: 15px">
                        <div class="p-mt-2 p-mr-3">Optional:</div>
                        <div style="flex-grow: 1">
                            <!-- <p-autoComplete [suggestions]="usersList" (completeMethod)="search($event.query)"
                                placeholder="Add optional attendees" name="usersList" id="usersList" field="name">
                            </p-autoComplete> -->
                            <p-autoComplete class="width-inherit" appendTo="body" field="name" name="optRecipients"
                                placeholder="Add optional attendees" id="optRecipients"
                                [(ngModel)]="optionalCalendarEventAttendees" [suggestions]="usersList" [completeOnFocus]="true"
                                [ngModelOptions]="{ standalone: true }" [multiple]="true"
                                (completeMethod)="search($event.query)" [disabled]="isViewMode">
                                <ng-template let-optRecipients pTemplate="item">
                                    {{
                                    optRecipients.name +
                                    "<" + optRecipients.emailId + ">" }} </ng-template>
                            </p-autoComplete>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-2">
                <label>Start Date</label>
                <p-calendar [(ngModel)]="startDate" id="startDate" name="startDate" placeholder="Select a date"
                    [minDate]="minimumDate" [keepInvalid]="true" [showIcon]="true" appendTo="body" (onSelect)="changeEndDate($event)"
                    [disabled]="isViewMode"></p-calendar>
                <small *ngIf="showValidation && !startDate" class="p-invalid">Start Date is required</small>
            </div>
            <div class="p-col-2">
                <label>Start Time</label>
                <p-calendar [(ngModel)]="startTime" id="startTime" name="startTime" placeholder="Select a time"
                    appendTo="body" [disabled]="disableTime" (onSelect)="changeEndTime($event)"
                    [timeOnly]="true" [hourFormat]="12" [disabled]="isViewMode"></p-calendar>
                <small *ngIf="showValidation && !startTime" class="p-invalid">Start Time is required</small>
            </div>
            <div class="p-col-2">
                <label>End Date</label>
                <p-calendar [(ngModel)]="endDate" id="endDate" name="endDate" placeholder="Select a date"
                    [minDate]="minimumDate" [keepInvalid]="true" [showIcon]="true" appendTo="body"
                    (onSelect)="changeMessage(selectedRepeat.name)" hourFormat="12" [disabled]="isViewMode">
                </p-calendar>
                <small *ngIf="showValidation && !endDate" class="p-invalid">End Time is required</small>
            </div>
            <div class="p-col-2">
                <label>End Time</label>
                <p-calendar [(ngModel)]="endTime" id="endTime" name="endTime" placeholder="Select a date"
                [timeOnly]="true" [hourFormat]="12" appendTo="body" (onSelect)="changeMessage(selectedRepeat.name)"
                [disabled]="isViewMode" [disabled]="disableTime"></p-calendar>
                <small *ngIf="showValidation && !endTime" class="p-invalid">End Date is required</small>
            </div>
            <div class="p-col-1 p-text-center p-mt-5 p-px-0">
                <p-checkbox name="allday" binary="true" [(ngModel)]="allDay"
                    (onChange)="changeRepeatType($event.checked)" value="All Day" inputId="allDay"
                    [disabled]="isViewMode">
                </p-checkbox>
                <label for="allday" class="p-d-inline-block p-mb-1 p-ml-2">All day</label>
            </div>
            <!-- <div class="p-col-2">
                <label>Repeat</label>
                <p-dropdown appendTo="body" [options]="repeats" (onChange)="changeMessage(selectedRepeat.name)"
                    [(ngModel)]="selectedRepeat" optionLabel="name"  [disabled]="allDay">
                </p-dropdown>
            </div>
            <div class="p-col-2">
                <label>Reminder</label>
                <p-dropdown appendTo="body" [options]="reminders" [(ngModel)]="selectedReminder" optionLabel="name"
                    >
                </p-dropdown>
            </div> -->
            <div class="p-col-3" style="padding-top: 30px; margin: auto">
                <div pButton *ngIf="mode != 'edit' && !isViewMode" type="button" label="Make Recurring"
                    (click)="showCustom()"></div>
                <div pButton *ngIf="mode == 'edit' && !isViewMode" type="button" label="Change Recurring"
                    (click)="showCustom()"></div>
            </div>
        </div>
        <!-- <div class="p-grid">
            <div class="p-col-12 p-md-9">
                <label>Timezone</label>
                <p-dropdown appendTo="body" [options]="timezones" [(ngModel)]="selectedtimeZone" optionLabel="name"
                    [disabled]="isViewMode" filter="true">
                </p-dropdown>
            </div>
            <div class="p-col-12 p-md-3">
                <label>Event Color</label>
                <p-colorPicker [(ngModel)]="color"></p-colorPicker>
            </div>
        </div> -->

        <p *ngIf="showMessage">
            <i class="pi pi-check-circle p-mr-1"></i>{{ evtMsg }}
        </p>
        <div class="p-grid">
            <div class="p-col-1">
                <label class="p-mr-3 p-mt-2">Location:</label>
            </div>
            <div class="p-col-8">
                <input [disabled]="isViewMode" type="text" pInputText
                    [(ngModel)]="eventTemp.calendarEvent.location" />
            </div>
            <div class="p-col-3">
                <div class="p-logo-section">
                    <ul class="logo-list p-d-flex">
                        <li class="logo">
                            <img [src]="assestBaseUrl + 'images/microsoft-teams-logo.jpg'" alt="Teams-icon" style="width:26px;height:26px"
                                alt="Teams" (click)="setOnlineMeetings('Teams')" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="p-grid" *ngIf="((mode !== 'edit') || eventFromModule)">
            <div class="p-col-12 p-md-6">
                <label>Related to</label>
                <p-dropdown [options]="taskModules" optionLabel="name" optionValue="id" [disabled]="isViewMode||eventFromModule"
                    [(ngModel)]="eventTemp.objectTypeId" [showClear]="true" (onChange)="onChangeModule($event.value,true)"  appendTo="body"
                    placeholder="Select Module">
                </p-dropdown>
            </div>

            <div class="p-col-12 p-md-6" *ngIf="[1,2].includes(eventTemp.objectTypeId)">
                <label for="channel">Channel</label>
                <p-dropdown [options]="channelsN" optionLabel="name"
                    optionValue="id"
                    [disabled]="isViewMode||eventFromModule"
                    (onChange)="onChangeChannel($event.value,true)"
                    [(ngModel)]="eventTemp.channelId" [showClear]="true" [filter]="true" [resetFilterOnHide]="true" appendTo="body" placeholder="Select Channel">
                </p-dropdown>
            </div>
            <!-- <div class="p-col-12 p-md-6">
                <label class="p-mb-2">Association</label>
                <p-autoComplete #associationNameDD name="associationNames" [(ngModel)]="this.eventTemp.objectTypeId)
                    [disabled]="mode === 'edit'" [suggestions]="associationNames" field="businessName" optionValue="id"
                    [completeOnFocus]="true" class="event-asso" (completeMethod)="searchAssociations($event)"
                    id="associationNames" [showClear]="true" appendTo="body" [disabled]="isViewMode">
                </p-autoComplete>
            </div> -->
            <div class="p-col-12 p-md-6">
                <label for="association">Association <span> <i style=" color: var(--primary-color);"  pTooltip="Edit" tooltipPosition="right" *ngIf="[1,2].includes(eventTemp.objectTypeId) && !eventFromModule &&  eventTemp.objectId" (click)="assignData()" class="pi pi-pencil"></i></span></label>
                <ng-container *ngIf="[1,2].includes(eventTemp.objectTypeId)">
                    <div class="association-container">
                        <span (click)="assignData()" *ngIf="!eventTemp.objectId" class="hyper-link"><strong
                                class="association-name"><i class="pi pi-plus p-mr-2"></i> Select Association</strong></span>
                        <ng-container *ngIf="eventTemp.objectId">
                            <p-chip styleClass="p-mr-2 custom-chip"  label="{{ eventTemp.objectId?.businessName }}" [removable]="!eventFromModule" (onRemove)="resetAssociation(eventTemp.objectId)">
                            </p-chip>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="![1,2].includes(eventTemp.objectTypeId)">
                    <p-autoComplete #associationNameDD name="associationNames" [(ngModel)]="eventTemp.objectId"
                        [disabled]="mode === 'edit'" [suggestions]="associationNames" field="businessName"
                        [completeOnFocus]="true" class="event-asso" (completeMethod)="searchAssociations($event)"
                        id="associationNames" [showClear]="true" appendTo="body" [disabled]="isViewMode||eventFromModule">
                    </p-autoComplete>
                </ng-container>
            </div>
        </div>

        <!-- <p-multiSelect [autoDisplayFirst]="false" [disabled]="eventFromModule" [options]="associationNames"
                        name="association" placeholder="Select Association" optionLabel="businessName"
                        (onFilter)="getAssociationNames($event.filter)" id="association" appendTo="body"
                        formControlName="association" dataKey="id" filter="true" [showClear]="true"
                        [panelStyle]="{'max-width':'500px'}" panelStyleClass="word-break"
                        emptyFilterMessage="No association name is found for this user.">
                    </p-multiSelect> -->

        <div class="p-grid">
            <div class="p-col-12">
                <label class="p-mx-0 p-my-2 p-d-block">Description</label>
                <p-editor [class.disable-editor]="isViewMode" [(ngModel)]="eventTemp.calendarEvent.description"
                    [ngModelOptions]="{standalone: true}" placeholder="Add your message..."
                    [style]="{ height: '220px' }" ngDefaultControl>
                </p-editor>
                <!-- <small *ngIf="eventTemp.calendarEvent.description.length>500" class="p-invalid">Description should be
                    within 500 characters</small> -->
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-1">
                <!-- <p-fileUpload mode="basic" name="demo[]" url="./upload.php" accept="image/*" maxFileSize="1000000"
                [chooseIcon]="'fa fa-paperclip'"></p-fileUpload> -->
                <p-fileUpload #fileUpload customUpload="true" mode="basic" [(files)]="files"
                     multiple="true" [showUploadButton]="false" [showCancelButton]="false" [chooseIcon]="'fa fa-paperclip'"
                    (onSelect)="uploadAttachments($event.files, fileUpload)">
                </p-fileUpload>
            </div>
            <div class="p-col-11">
                <div>
                    <!-- <ng-container *ngFor="let attachment of eventAttachments; let i = index;">
                        <a *ngIf="attachment?.downloadLink" target="_blank" href="{{attachment?.downloadLink}}">{{ attachment.name }}
                            <span *ngIf="eventAttachments.length>1 && i !== eventAttachments.length-1">, </span>
                        </a>
                        <a>{{ attachment.name }}
                            <span *ngIf="eventAttachments.length>1 && i !== eventAttachments.length-1">, </span>
                        </a>
                    </ng-container> -->
                    <ng-container *ngIf="eventAttachments && (eventAttachments?.length > 0)">
                        <app-lion-attachment-chips
                            [source]="attachmentSource"
                            [attachments]="eventAttachments"
                            [enableDownload]="enableDownloadForAttachment"
                            (removeAttachment)="removeAttachment($event)"></app-lion-attachment-chips>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancel()" class="p-button-secondary" label="Cancel"></button>
        <button *ngIf="!isViewMode" type="button" pButton [disabled]="disableSubmitButton"
            (click)="createEvent.ngSubmit.emit()" label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Appointment Recurrence" class="opportunity-task" [(visible)]="displayCustom"
    [modal]="true" [responsive]="true" [style]="{ width: '60em' }" appendTo="body">
    <div class="header">
        <h5>Appointment time</h5>
    </div>
    <div class="card" style="height:auto !important">
        <div class="p-field p-grid">
            <div class="p-col-12 p-lg-4">
                <label style="display:block">Start</label>
                <p-calendar id="startDate" name="startDate" placeholder="Select a date" [minDate]="minimumDate" [keepInvalid]="true"
                    [(ngModel)]="tempReccurringEvent.calenderEventStartDate" [showIcon]="true" appendTo="body"
                    showTime="true" hourFormat="12"></p-calendar>
            </div>
            <div class="p-col-12 p-lg-4">
                <label style="display:block">End</label>
                <p-calendar id="endDate" name="endDate" placeholder="Select a date" [minDate]="minimumDate" [keepInvalid]="true"
                    [(ngModel)]="tempReccurringEvent.calenderEventEndDate" [showIcon]="true" appendTo="body"
                    showTime="true" hourFormat="12"></p-calendar>
            </div>
            <div class="p-col-12 p-lg-4">
                <label>Duration</label>
                <p-dropdown appendTo="body" [options]="reminders" optionLabel="name"
                    [(ngModel)]="tempReccurringEvent.reminderInMinutes"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="header">
        <h5>Recurrence pattern</h5>
    </div>
    <div class="card"  style="height:auto !important">
        <div class="p-field p-grid">
            <div class="p-col-12 p-lg-2 border-right">
                <div *ngFor="let r of repeats" class="p-field-checkbox">
                    <p-radioButton inputId="r.value" name="r" [value]="r" [(ngModel)]="selectedCustomRepeat"
                        ngDefaultControl>
                    </p-radioButton>
                    <label [for]="r.value">{{ r.name }}</label>
                </div>
            </div>
            <div class="p-col-12 p-lg-10" *ngIf="selectedCustomRepeat">
                <ng-container *ngIf="selectedCustomRepeat.name === 'Daily'">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="day" value="Every day" [(ngModel)]="selectedDay" inputId="every"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="every">Every </label>
                        <p-dropdown [options]="dayNumbers" [(ngModel)]="selectedDayNumber" class="numbers p-ml-2"
                            optionLabel="name" [disabled]="selectedDay == 'Every weekday'">
                        </p-dropdown>
                        <label for="every"> day(s)</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="day" value="Every weekday" [(ngModel)]="selectedDay" inputId="weekday"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="weekday">Every weekday</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="selectedCustomRepeat.name === 'Weekly'">
                    <label style="display: inline-block">Recur every </label>
                    <p-dropdown [options]="weekNumbers" [(ngModel)]="selectedWeekNumber" class="numbers p-ml-2 p-mr-2"
                        optionLabel="name"></p-dropdown>
                    <label style="display: inline-block"> week(s) on:</label>
                    <div class="p-grid weekly p-py-2">
                        <ng-container *ngFor="let day of weekDays; let i = index">
                            <div class="p-col-3">
                                <p-checkbox value="Week Days" [(ngModel)]="day.checked" binary="true" [value]="day"
                                    [inputId]="day.value">
                                </p-checkbox>
                                <label style="display: inline-block" [for]="day.value" class="p-pl-2 p-mb-0">
                                    {{ day.name }}
                                </label>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="selectedCustomRepeat.name === 'Monthly'">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="month" value="Day" [(ngModel)]="selectedMonth" inputId="monthDay"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="monthDay">Day </label>
                        <p-inputNumber [useGrouping]="false" [(ngModel)]="monthDay1" class="numbers p-ml-4"
                            [disabled]="selectedMonth == 'The'"></p-inputNumber>
                        <label for="monthDay">of every</label>
                        <p-inputNumber [useGrouping]="false" [(ngModel)]="monthDay2" class="numbers p-ml-2"
                            [disabled]="selectedMonth == 'The'"></p-inputNumber>
                        <label for="monthDay">month(s)</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="month" value="The" [(ngModel)]="selectedMonth" inputId="monthWeek"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="monthWeek">The</label>
                        <p-dropdown [options]="monthWeeks" [(ngModel)]="selectedMonthWeek" class="p-ml-4"
                            optionLabel="name" [disabled]="selectedMonth == 'Day'"></p-dropdown>
                        <p-dropdown [options]="weekDays" [(ngModel)]="selectedWeek" class="p-ml-2" optionLabel="name"
                            [disabled]="selectedMonth == 'Day'"></p-dropdown>
                        <label for="monthWeek">of every</label>
                        <p-inputNumber [useGrouping]="false" [(ngModel)]="monthDay1" class="numbers p-ml-2"
                            [disabled]="selectedMonth == 'Day'"></p-inputNumber>
                        <label for="monthWeek">month(s)</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="selectedCustomRepeat.name === 'Yearly'">
                    <label style="display: inline-block">Recur every </label>
                    <p-dropdown [options]="yearNumbers" [(ngModel)]="selectedYearNumber" class="numbers p-ml-2 p-mr-2"
                        optionLabel="name"></p-dropdown>
                    <label style="display: inline-block"> year(s)</label>

                    <div class="p-field-radiobutton">
                        <p-radioButton name="year" value="On" [(ngModel)]="selectedYear" inputId="yearDay"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="yearDay">On: </label>
                        <p-dropdown [options]="monthNames" [(ngModel)]="selectedYearMonth" class="p-ml-4"
                            optionLabel="label" [disabled]="selectedYear == 'On the'"></p-dropdown>
                        <p-inputNumber [useGrouping]="false" [(ngModel)]="yearDay" class="numbers p-ml-2"
                            [disabled]="selectedYear == 'On the'"></p-inputNumber>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="year" value="On the" [(ngModel)]="selectedYear" inputId="yearWeek"
                            ngDefaultControl>
                        </p-radioButton>
                        <label for="yearWeek">On the: </label>
                        <p-dropdown [options]="monthWeeks" [(ngModel)]="selectedYearCount" class="p-ml-4"
                            optionLabel="name" [disabled]="selectedYear == 'On'"></p-dropdown>
                        <p-dropdown [options]="weekDays" [(ngModel)]="selectedYearWeek" class="p-ml-2"
                            optionLabel="name" [disabled]="selectedYear == 'On'"></p-dropdown>
                        <p-dropdown [options]="monthNames" [(ngModel)]="selectedYearMonth2" class="p-ml-2"
                            optionLabel="label" [disabled]="selectedYear == 'On'"></p-dropdown>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="header">
        <h5>range of recurrence</h5>
    </div>
    <div class="card" style="padding-bottom: 70px;height:auto !important">
        <div class="p-field p-grid">
            <div class="p-col-6 p-lg-1">
                <label>Start: </label>
            </div>
            <div class="p-col-6 p-lg-3">
                <div style="margin: 0.5rem 0">
                    <p-calendar id="startDate" name="startDate" placeholder="Select a date" [minDate]="minimumDate" [keepInvalid]="true"
                        [showIcon]="true" appendTo="body" [(ngModel)]="tempReccurringEvent.startDate"></p-calendar>
                </div>
            </div>
            <div class="p-col-6 p-lg-2">
                <div class="p-field-radiobutton">
                    <p-radioButton name="end" value="End by" [(ngModel)]="selectedEnd" inputId="end1" ngDefaultControl>
                    </p-radioButton>
                    <label for="end1">End by:</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton name="end" value="End after" [(ngModel)]="selectedEnd" inputId="end2"
                        ngDefaultControl>
                    </p-radioButton>
                    <label for="end2">End after:</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton name="end" value="No end date" [(ngModel)]="selectedEnd" inputId="end3"
                        ngDefaultControl>
                    </p-radioButton>
                    <label for="end3">No end date</label>
                </div>
            </div>
            <div class="p-col-6 p-lg-6">
                <div class="p-mt-1">
                    <p-calendar id="endDate" name="endDate" placeholder="Select a date" [minDate]="minimumDate" [keepInvalid]="true"
                        [showIcon]="true" appendTo="body" [(ngModel)]="tempReccurringEvent.endDate" [disabled]="
                            selectedEnd == 'End after' ||
                            selectedEnd == 'No end date'
                        "></p-calendar>
                </div>
                <div class="p-mt-1">
                    <p-dropdown [options]="counts" class="numbers p-mr-2" optionLabel="name"
                        [(ngModel)]="tempReccurringEvent.maxNoOfOccurrence" placeholder="Count" [disabled]="
                            selectedEnd == 'End by' ||
                            selectedEnd == 'No end date'
                        "></p-dropdown>
                    <label style="display: inline-block">occurences</label>
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="resetCustomRecurring()" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveCustomRecurring()"></button>
        <!-- <button pButton label="Remove Recurrence" disabled></button> -->
    </ng-template>
</p-dialog>


<app-shared-manual-modal [displayPopup]="displayManualPopup"  [singleSelection]="true"
    [colsList]="manualRuleColumnSetttings"  [selectedObjectType]="selectedModule"
    [selectedTemplateType]="{id: eventTemp.channelId}" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveAssignData($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
